(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modern-wink-home"] && !Shopify.designMode) return;
  try {
    
  const initializeModernWinkHomeMotion = (scope = document) => {
    if (!('IntersectionObserver' in window)) return;

    scope.querySelectorAll('.mw-home:not(.mw-motion-ready)').forEach((home) => {
      const targets = home.querySelectorAll('[data-mw-reveal]');
      targets.forEach((target, index) => {
        target.style.setProperty('--mw-reveal-delay', `${Math.min(index % 3, 2) * 70}ms`);
      });

      home.classList.add('mw-motion-ready');
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-mw-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
      );
      targets.forEach((target) => observer.observe(target));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeModernWinkHomeMotion());
  } else {
    initializeModernWinkHomeMotion();
  }

  document.addEventListener('shopify:section:load', (event) => initializeModernWinkHomeMotion(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modern-wink-product-details"] && !Shopify.designMode) return;
  try {
    
  const updateModernWinkVariantFieldset = (fieldset) => {
    const checked = fieldset.querySelector('input[type="radio"]:checked');
    const legend = fieldset.querySelector('legend');
    if (!legend || !checked) return;

    let selectedValue = legend.querySelector('.mw-variant-value');
    if (!selectedValue) {
      selectedValue = document.createElement('span');
      selectedValue.className = 'mw-variant-value';
      legend.append(selectedValue);
    }
    if (selectedValue.textContent !== checked.value) {
      selectedValue.textContent = checked.value;
    }

    const optionName = (checked.dataset.optionName || '').toLowerCase();
    fieldset.classList.toggle('mw-variant-option--color', optionName === 'color' || optionName === 'colour');
  };

  const animateModernWinkVariantMedia = (colorValue) => {
    if (!colorValue || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const main = document.querySelector('#MainContent');
    if (!main) return;

    let hasAnimated = false;
    let stopTimer;
    const revealMatchingMedia = () => {
      if (hasAnimated) return true;

      const image = Array.from(
        document.querySelectorAll('.product-information__media img.product-media__image')
      ).find((candidate) => {
        return candidate.alt.includes(colorValue) && candidate.offsetWidth > 0 && candidate.offsetHeight > 0;
      });
      if (!image) return false;

      hasAnimated = true;
      image.dataset.mwMediaAnimated = colorValue;
      image.animate(
        [
          { opacity: 0.2, transform: 'translateY(10px) scale(0.965)', filter: 'blur(5px)' },
          { opacity: 1, transform: 'translateY(0) scale(1)', filter: 'blur(0)' },
        ],
        { duration: 560, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
      );
      mediaObserver.disconnect();
      window.clearTimeout(stopTimer);
      return true;
    };

    const mediaObserver = new MutationObserver(revealMatchingMedia);
    mediaObserver.observe(main, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'hidden', 'style'],
    });

    window.requestAnimationFrame(() => window.requestAnimationFrame(revealMatchingMedia));
    stopTimer = window.setTimeout(() => {
      revealMatchingMedia();
      mediaObserver.disconnect();
    }, 1800);
  };

  const initializeModernWinkProductEnhancements = () => {
    document.querySelectorAll('variant-picker').forEach((picker) => {
      picker.classList.add('mw-variant-picker');
      picker.querySelectorAll('fieldset').forEach(updateModernWinkVariantFieldset);

      if (picker.dataset.mwEnhanced === 'true') return;
      picker.dataset.mwEnhanced = 'true';
      picker.addEventListener('change', (event) => {
        const fieldset = event.target.closest('fieldset');
        if (!fieldset) return;

        updateModernWinkVariantFieldset(fieldset);
        const optionName = (event.target.dataset.optionName || '').toLowerCase();
        if (optionName === 'color' || optionName === 'colour') {
          animateModernWinkVariantMedia(event.target.value);
        }
      });
    });

    if (!('IntersectionObserver' in window)) return;
    const main = document.querySelector('#MainContent');
    if (!main || main.classList.contains('mw-product-motion-ready')) return;

    const targets = main.querySelectorAll(
      '[data-testid="product-information-details"], .mw-product-details__intro, .mw-product-details__cards article, .mw-product-details__content > div, .mw-product-details__service'
    );
    targets.forEach((target, index) => {
      target.dataset.mwProductReveal = '';
      target.style.setProperty('--mw-reveal-delay', `${Math.min(index % 3, 2) * 70}ms`);
    });

    main.classList.add('mw-product-motion-ready');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-mw-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    targets.forEach((target) => observer.observe(target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeModernWinkProductEnhancements);
  } else {
    initializeModernWinkProductEnhancements();
  }

  const modernWinkProductObserver = new MutationObserver(() => initializeModernWinkProductEnhancements());
  const modernWinkProductMain = document.querySelector('#MainContent');
  if (modernWinkProductMain) {
    modernWinkProductObserver.observe(modernWinkProductMain, { childList: true, subtree: true });
  }

  } catch(e) { console.error(e); }
})();
})();
